import type { ReactNode } from 'react';
import { useNav } from '../app/nav.tsx';
import { AN_LVL, cuidadosOf, type Answers } from '../lib/anamnese.ts';
import { first, initials, tone } from '../lib/format.ts';
import { Icon } from './Icon.tsx';

export const Gr = ({ label, value, extra, cls }: { label: string; value: ReactNode; extra?: ReactNode; cls?: string }) => (
  <div className={'gl-row' + (cls ? ' ' + cls : '')}><span>{label}</span><b>{value}</b>{extra}</div>
);

export const Avatar = ({ id, name, extra }: { id: string; name: string; extra?: string }) => (
  <span className={`av t-${tone(id)}${extra ? ' ' + extra : ''}`}>{initials(name)}</span>
);

export function CareBlock({ clientId, name, answers, compact }: { clientId: string; name: string; answers: Answers | null | undefined; compact?: boolean }) {
  const nav = useNav();
  let l = cuidadosOf(answers);
  if (!l.length) return null;
  if (compact) l = l.filter((x) => x.lvl !== 'info').concat(l.filter((x) => x.lvl === 'info').slice(0, 2));
  return (
    <div className="an-care">
      <div className="an-care-h"><Icon name="alert" /><b>Cuidados com a {first(name)}</b><button onClick={() => nav.open({ kind: 'anamnese', clientId })}>Ver anamnese</button></div>
      <ul>{l.map((x, i) => <li key={i} className={'lv-' + x.lvl}><span>{AN_LVL[x.lvl]}</span><p><b>{x.src}.</b> {x.txt}</p></li>)}</ul>
    </div>
  );
}

export function Chips<T extends string>({ value, options, onChange }: { value: T | null; options: Array<[T, string]>; onChange: (v: T) => void }) {
  return (
    <div className="chipset soft">
      {options.map(([k, l]) => <button key={k} className={value === k ? 'on' : ''} aria-pressed={value === k} onClick={() => onChange(k)}>{l}</button>)}
    </div>
  );
}
